module.exports = __webpack_public_path__ + "static/media/George H. W. Bush (I) - 1992.11ba5d01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/George H. W. Bush (I) - 1992.jpg
// module id = 472
// module chunks = 0